import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=1c57e8fc"
import script from "./AlertIcon.vue?vue&type=script&lang=js"
export * from "./AlertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports